import { Banner } from '@@types'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'

import { cn } from '@shared/lib/cn'

import BannerItem from './item'

import styles from './styles.module.scss'

export type { BannerItemProps } from './item'

interface BannerCarouselProps {
  banners: (Banner)[] | null;
  loading?: boolean;
  size?: 'small' | 'big' | 'default';
}

function BannerSkeleton () {
  return (
    <SkeletonTheme>
      <Skeleton
        width={'100%'}
        style={{
          borderRadius: 12,
          aspectRatio: '2.8/1',
          minHeight: '180px',
        }}
      />
    </SkeletonTheme>
  )
}

export default function BannerCarousel (props: BannerCarouselProps) {
  const { banners = [], loading, size = 'default' } = props

  const isTablet = useMediaQuery('(max-width: 768px')
  
  const showNavigation = !isTablet && banners && banners.length > 1
  
  const getSwiperConfig = () => {
    switch (size) {
    case 'small':
      return {
        slidesPerView: isTablet ? 2 : 3,
        spaceBetween: isTablet ? 12 : 16,
        loop: false,
        autoplay: { delay: 5000, disableOnInteraction: false }
      }
    case 'big':
      return {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: banners && banners.length > 1,
        autoplay: { delay: 8000, disableOnInteraction: false }
      }
    default:
      return {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: banners && banners.length > 1,
        autoplay: { delay: 7000, disableOnInteraction: false }
      }
    }
  }
  
  const config = getSwiperConfig()

  if (loading) {
    return <BannerSkeleton />
  }

  return (
    <>
      {banners && banners.length > 0 && (
        <Swiper
          className={cn(
            '_navigation-center', 
            styles.swiper,
            size === 'small' && styles.swiperSmall,
            size === 'big' && styles.swiperBig
          )}
          modules={[ Navigation ]}
          slidesPerView={config.slidesPerView}
          spaceBetween={config.spaceBetween}
          navigation={showNavigation || false}
          loop={Boolean(config.loop)}
          autoplay={config.autoplay}
          breakpoints={{
            0: {
              slidesPerView: size === 'small' ? 1 : 1,
              centeredSlides: size !== 'small',
            },
            481: {
              slidesPerView: size === 'small' ? 2 : 1,
            },
            769: {
              slidesPerView: config.slidesPerView,
            },
          }}
        >
          {banners &&
            banners.map((item) => {
              return (
                <SwiperSlide className={styles.slide} key={item?.id}>
                  <BannerItem
                    id={String(item?.id)}
                    title={item?.name}
                    imageDesktop={item?.bannerSlide?.url}
                    imageMobile={item?.bannerMobileSlide?.url}
                    buttonLink={item?.url as string}
                    buttonText={item?.button_text as string}
                    openInNewTab={item?.optionOpenInNewWindow || false}
                    size={size}
                  />
                </SwiperSlide>
              )
            })}
        </Swiper>
      )}
    </>
  )
}
